const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__copyright">
        © {new Date().getFullYear()} SolExpress. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
